export function attacScript(source) {
  var head = document.head || document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.charset = 'utf8'
  script.type = 'text/javascript';
  script.textContent = source
  head.appendChild(script)
}

export function loadScript(url) {
  return new Promise((resolve, reject) => {
    var head = document.head || document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    script.async = true
    script.src = url
    script.charset = 'utf8'

    head.appendChild(script)

    script.onload = resolve
    script.onerror = reject
  })
}

export function merge(obj, src) {
  Object.keys(src).forEach(function (key) {
    if (obj[key] && typeof obj[key] === 'object') {
      merge(obj[key], src[key])
      return
    }
    obj[key] = src[key]
  })

  return obj
}

export function hasScript() {
  const scriptTags = Array.prototype.slice.call(
    document.getElementsByTagName('script')
  ).filter(script => {
    return (script.src.indexOf('analytics') !== -1) ||
      (script.src.indexOf('gtag') !== -1)
  })

  return scriptTags.length > 0
}

export function shouldGaLoad() {
  return !hasScript()
}
